<template>
  <div class="common-header flex justify-between">
    <div class="left flex align-center">
      <img src="@/assets/image/logo.png" alt="" />
      <div class="font-24">大转盘抽奖(企业版)PC端 <span>（Beta版本）</span></div>
    </div>
    <slot name="right">
      <div class="right flex align-center">
        <img :src="userInfo.avatar" alt="" />
                <p>{{ userInfo.username }}</p>
        <el-dropdown>
          <span class="el-dropdown-link">
            <i class="el-icon-arrow-down"></i>
          </span>
          <template #dropdown>
            <el-dropdown-menu>
              <el-dropdown-item icon="el-icon-switch-button" @click.native="logout">退出登录</el-dropdown-item>
              <!-- <el-dropdown-item icon="el-icon-help" @click="toHelp">
                使用帮助
              </el-dropdown-item>
              <el-dropdown-item icon="el-icon-s-order" @click="toOrder">
                订单中心
              </el-dropdown-item> -->
            </el-dropdown-menu>
          </template>
        </el-dropdown>
      </div>
    </slot>
  </div>
</template>
<script>
export default {
  name: 'common-header',
  data() {
    return {
      userInfo: {
        avatar: 'https://static.goubudian.com/Uploads/lottery/2305/647315c3c7b87.png',
        username: ''
      }
    }
  },
  components: {

  },
  methods: {
    logout() {
      // localStorage.clear()
      this.$cookie.delCookie('token')
      this.$router.push('/')
    },
    toHelp() {
      this.$router.push('/help')
    },
    toOrder() {
      this.$router.push('/orderlist')
    }
  }
}
</script>
<style scoped lang="scss">
.common-header {
  box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.16);
  padding: 11px 77px;
  position: relative;
  z-index: 2;

  .left {
    div {
      padding-left: 15px;
      span{
        font-size: 14px;
        color: #999;
      }
    }
  }

  .right {
    .icon {
      width: 24px;
      height: 24px;
      margin-right: 20px;

      &:nth-last-child(1) {
        margin-right: 0;
      }
    }

    p {
      padding: 0 10px 0 5px;
    }
  }

  img {
    width: 34px;
    height: 34px;
    border-radius: 17px;
    vertical-align: middle;
  }
}

.logout {
  cursor: pointer;
  padding: 4px 0;

  .icon {
    width: 16px;
    height: 16px;
    padding-right: 10px;
  }
}

.line {
  height: 1px;
  width: 100%;
  background-color: #ccc;
}
</style>



// WEBPACK FOOTER //
// src/components/header.vue